import styled from 'styled-components'

import { BaseBadgeStyles, type IBaseBadgeProps } from './BaseBadgeStyles'

export const AIStatusBadgeStyled = styled.span<IBaseBadgeProps>`
  ${BaseBadgeStyles}

  gap: ${(props) => props.theme.space.xsmall};

  color: ${(props) => props.theme.colors.badge.ai.content};
  background: ${(props) => props.theme.colors.badge.ai.background};
`
